module.exports = __webpack_public_path__ + "static/media/brain-2.70a40fe3.png";